import { action } from '../../utils/action'
import * as t from './actionTypes'

export const dismissAlert = (id, previousStatus) => action(t.DISMISS_ALERT, { id, previousStatus })

export const dismissAlertGroup = groupName => action(t.DISMISS_ALERT_GROUP, { groupName })
